.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: var(--color-overlay);
}

.content {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  width: calc(100% - var(--space-8));
  height: fit-content;
  max-height: calc(100dvh - var(--space-16));
  margin: auto;
  overflow-y: auto;
  padding: var(--space-5);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-3);
  color: var(--color-fg);
}

.md {
  max-width: var(--size-dialog);
}

.lg {
  max-width: var(--size-dialog-lg);
}

.title {
  padding-right: var(--space-8);
  font-size: var(--text-lg);
  line-height: var(--lh-lg);
}

.description {
  margin-top: var(--space-1);
  color: var(--color-fg-muted);
}

.body {
  margin-top: var(--space-4);
}

.close {
  position: absolute;
  top: var(--space-4);
  right: var(--space-4);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
  margin-top: var(--space-6);
}
